// Apollo
import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';

// Update
import UpdatePlaceholderTeam from '@/graphql/placeholder_teams/update/updatePlaceholderTeam.gql';
import updatePlaceholderTeamName from '@/graphql/placeholder_teams/update/updatePlaceholderTeamName.gql';
import CreatePlaceholderTeams from '@/graphql/placeholder_teams/create/CreatePlaceholderTeams.gql';

export default {
	state: {
		placeholderTeams: [] as HasuraPlaceholderTeam[],
	},

	// ================ Getters ================
	getters: {
		placeholderTeams(state: any) {
			return state.placeholderTeams;
		},
	},

	// ================ Mutations ================
	mutations: {
		setPlaceholderTeams(state: any, placeholderTeams: any) {
			state.placeholderTeams = placeholderTeams;
		},
	},

	// ================= Actions =================
	actions: {
		async getPlaceholderTeams({ commit }: any) {
			const response = await apolloClient.query({
				query: gql`
					query MyQuery {
						placeholderTeams {
							id
							first_name
							last_name
							phone_number
							email
							city
							cityByCity {
								country {
									id
								}
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});

			const { placeholderTeams } = response.data;
			commit('setPlaceholderTeams', placeholderTeams);
			return;
		},

		async createPlaceholderTeams({ dispatch }: any, payload: any) {
			console.log("payload", payload)
			const objects = payload.map((ph: any) => {
				return {
					id: ph.id,
					name: ph.name,
					type: ph.type,
					carry_points: ph.carry_points,
					seeding_league: ph.seeding_league,
					seeding_group: ph.seeding_group,
					seeding_position: ph.seeding_position,
					seeding_match: ph.seeding_match,
					parent_finals: ph.parent_finals,
					parent_league: ph.parent_league,
					parent_group: ph.parent_group,
				} as HasuraPlaceholderTeam;
			});


			const res: any = await apolloClient
				.mutate({
					mutation: CreatePlaceholderTeams,
					// Parameters
					variables: {
						objects,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			// dispatch('getPlaceholderTeams');
			return;
		},

		async deletePlaceholderTeams({ dispatch }: any, arrayOfIds: any) {
			const promises = arrayOfIds.map((id: string) => {
				return apolloClient.mutate({
					mutation: gql`
						mutation deletePaceholderTeams($id: uuid!) {
							delete_placeholder_teams(where: { id: { _eq: $id } }) {
								returning {
									id
								}
							}
						}
					`,
					// Parameters
					variables: {
						id,
					},
				});
			});

			try {
				await Promise.all(promises);
			} catch (error) {
				console.error(error);
			}

			return;
		},

		async updatePlaceholderTeams({ dispatch }: any, payload: any) {
			const promises = payload.map((t: any) => {
				// console.log('t');
				// console.log(t);
				return apolloClient.mutate({
					mutation: UpdatePlaceholderTeam,
					// Parameters
					variables: {
						id: t.id,
						object: t,
					},
				});
			});

			await Promise.all(promises);

			// const { firstName, lastName, phoneNumber, email, city, id } = payload;
			// await apolloClient.mutate({
			// 	mutation: UpdatePlaceholderTeam,
			// 	// Parameters
			// 	variables: {
			// 		refereeId: id,
			// 		firstName,
			// 		lastName,
			// 		phoneNumber,
			// 		email,
			// 		city,
			// 	},
			// });

			// dispatch('getPlaceholderTeams');
			return;
		},
		async updatePlaceholderTeamName({ dispatch }: any, payload: any) {
			try {
				await apolloClient.mutate({
					mutation: updatePlaceholderTeamName,
					variables: {
						id: payload.id,
						name: payload.name,
					},
				});
				return;
			} catch (error) {
				console.log('error updating name', error);
			}
		},
	},
};
